import styled from "@emotion/styled";
import { alpha } from "@kaltura/mediaspace-shared-styled";
import { keyframes } from "@emotion/react";
import { Link } from "@kaltura/ds-react-components";
import { VisibleFocusStyle } from "@kaltura/ds-react-theme";

export const StyledCard = styled("div")(({ theme }) => ({
    ":focus-visible": VisibleFocusStyle,
    minWidth: 0, // Enable truncation in grid layout
    display: "flex",
    flexDirection: "column",
}));

export const StyledThumbnail = styled(Link)(({ theme }) => ({
    display: "block",
    width: "100%",
    paddingBottom: "56.25%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: theme.kaltura.shape.roundness2,
    position: "relative",
    marginBottom: theme.spacing(2),
    backgroundColor: theme.kaltura.palette.tone4,
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    display: "inline-block",
    textDecoration: "none",
    ":focus-visible": VisibleFocusStyle,
    ":hover, :focus, :active": {
        color: theme.kaltura.palette.tone1,
    },
}));

export const StyledInfo = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    color: theme.kaltura.palette.tone2,
}));

export const Separator = styled("div")(({ theme }) => ({
    width: theme.spacing(0.5),
    height: theme.spacing(0.5),
    backgroundColor: theme.kaltura.palette.tone2,
    borderRadius: "50%",
}));

export const StyledActions = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
}));

const slideUp = keyframes`
    from {
        transform: translateY(8px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

export const StyledMediaCount = styled("div")(({ theme }) => ({
    position: "absolute",
    left: theme.spacing(1),
    bottom: theme.spacing(1),
    color: theme.kaltura.palette["translucent"].main,
    backgroundColor: alpha(theme.kaltura.palette["translucent"].dark, 0.6),
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
    padding: theme.spacing(0.75),
    borderRadius: theme.kaltura.shape.roundness1,
    animation: `${slideUp} 0.8s ease-out`,
}));
